var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBioluminescent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 81.26 81.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 81.26,
    height: 81.26
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m.04,40.64C.04,62.83,17.83,80.86,39.91,81.26h1.51c21.56-.39,39.02-17.58,39.84-39.04v-3.16C80.43,17.36,62.57.02,40.67.02S.04,18.21.04,40.64"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -1.83,
    cy: -178.13,
    fx: -1.83,
    fy: -178.13,
    r: 0.96,
    gradientTransform: "translate(118.43 -7532.21) scale(42.51 -42.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#f9fbfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#f5f8fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ebeff5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8697aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#475f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2f4a68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08162a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.04,
    y: 0.02,
    width: 81.22,
    height: 81.24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBioluminescent);
export default __webpack_public_path__ + "static/media/Bioluminescent.b23be7ba71f74e052f3d9cb187cdc739.svg";
export { ForwardRef as ReactComponent };